    
class CourseDetails {
    constructor(name, description, template, uploadedFiles, courseOutline) {
        this.name = name;
        this.description = description;
        this.template = template;
        this.uploadedFiles = uploadedFiles;
        this.courseOutline = courseOutline;
    }
}

export default CourseDetails;
